/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Flex, Space, Text } from '@sonyged/proc-ui';
import { variant } from 'styled-system';
import css from '@styled-system/css';

import { ArrowIcon, LossColor } from '../../common/components/ArrowIcon';
import type { Customer } from '../rules/types';
import { CustomerIcon } from './CustomerIcon';

type Props = {
  advanced?: boolean,
  title: string,
  score: number | null,
  customerGroup: Array<Customer>,
  disabled?: boolean,
  variant: 'past' | 'future' | 'current',
};

export function FieldRoundCard(props: Props) {
  const { advanced, title, score, customerGroup, disabled, variant, ...rest } = props;

  return (
    <Container {...rest} variant={variant} disabled={disabled}>
      <Flex alignItems="flex-end">
        <Text
          className="title"
          color="secondary100"
          lineHeight={1}
          fontSize={['mobile.small', 'smallPC.small', 'largePC.small']}
        >
          {title}
        </Text>
        {score !== null && (
          <Box flex={1} textAlign="right">
            <Text
              color={score < 0 ? LossColor : null}
              lineHeight={1}
              fontSize={['mobile.medium', 'smallPC.medium', '30px']}
            >
              {Math.abs(score)}
            </Text>
            <Text
              color={score < 0 ? LossColor : null}
              lineHeight={1}
              fontSize={['mobile.small', 'smallPC.small', 'largePC.small']}
            >
              {' 円 '}
            </Text>
            {advanced && <ArrowIcon forNum={score} className="proc-medium-font" />}
          </Box>
        )}
      </Flex>

      <Box mt={['4px', '4px', '8px']} className="customerIcon">
        <Space mr={['4px', '4px', '8px']}>
          {customerGroup.map((customer, i) => (
            <CustomerIcon key={i} customer={customer} />
          ))}
        </Space>
      </Box>
    </Container>
  );
}

const Container = styled(Box)(
  ({ disabled }) =>
    css({
      borderRadius: ['8px', '8px', '15px'],
      minHeight: ['70px', '70px', '110px'],
      px: ['16px', '16px', '24px'],
      py: ['12px', '12px', '16px'],
      opacity: disabled ? 0.2 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
    }),
  variant({
    variants: {
      current: {
        opacity: 1,
        bg: 'white',
        cursor: 'pointer',
      },
      future: {
        opacity: 0.2,
        bg: 'white',
        cursor: 'not-allowed',
      },
      past: {
        opacity: 1,
        bg: 'rgba(255, 255, 255, 0.75)',
        cursor: 'pointer',
        '.customerIcon, .title': {
          opacity: 0.3,
        },
      },
    },
  })
);
